import { CommonModule, registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { NgModule } from '@angular/core';
import { PaymentType } from '@spartacus/cart/base/root';
import { Address, CmsBannerComponentMedia, CmsResponsiveBannerComponentMedia, Currency, Occ, Principal, User } from '@spartacus/core';
import { LAUNCH_CALLER, Media } from '@spartacus/storefront';
import { CustomAccordionModule } from '../custom/cms-components/content/custom-accordion/custom-accordion.module';
import { CustomItemAccordionModule } from '../custom/cms-components/content/custom-accordion/custom-item-accordion/custom-item-accordion.module';
import { CustomAdditionalTextPdpModule } from '../custom/cms-components/content/custom-additional-text-pdp/custom-additional-text-pdp.module';
import { CustomButtonSwitchModule } from '../custom/cms-components/content/custom-button-switch/custom-button-switch.module';
import { CustomCategoryCarouselModule } from '../custom/cms-components/content/custom-category-carousel/custom-category-carousel.module';
import { CustomCmsItemComponent } from '../custom/cms-components/content/custom-cms-item/custom-cms-item.component';
import { CustomCmsItemModule } from '../custom/cms-components/content/custom-cms-item/custom-cms-item.module';
import { CustomCollectionsModule } from '../custom/cms-components/content/custom-collections/custom-collections.module';
import { CustomDoubleBannerModule } from '../custom/cms-components/content/custom-double-banner/custom-double-banner.module';
import { CustomHeaderCategoryModule } from '../custom/cms-components/content/custom-header-category/custom-header-category.module';
import { CustomHelpModule } from '../custom/cms-components/content/custom-help/custom-help.module';
import { CustomInfoBoxesModule } from '../custom/cms-components/content/custom-info-boxes/custom-info-boxes.module';
import { CustomInfoboxformModule } from '../custom/cms-components/content/custom-infoboxform/custom-infoboxform.module';
import { CustomItemCategoryBlocksComponentModule } from '../custom/cms-components/content/custom-item-category-blocks-component/custom-item-category-blocks-component.module';
import { CustomItemInfoBoxModule } from '../custom/cms-components/content/custom-item-info-box/custom-item-info-box.module';
import { CustomItemVerticalFourModule } from '../custom/cms-components/content/custom-item-vertical-four/custom-item-vertical-four.module';
import { CustomItemVerticalTwoAndThreeSelectionModule } from '../custom/cms-components/content/custom-item-vertical-two-and-three-selection/custom-item-vertical-two-and-three-selection.module';
import { CustomLinkListModule } from '../custom/cms-components/content/custom-link-list/custom-link-list.module';
import { CustomLogoModule } from '../custom/cms-components/content/custom-logo/custom-logo.module';
import { CustomMoreInfoModule } from '../custom/cms-components/content/custom-more-info/custom-more-info.module';
import { CustomNewsletterModule } from '../custom/cms-components/content/custom-newsletter/custom-newsletter.module';
import { CustomOhgarBannerAndProductsModule } from '../custom/cms-components/content/custom-ohgar-banner-and-products/custom-ohgar-banner-and-products.module';
import { CustomOhgarCategoryBlocksModule } from '../custom/cms-components/content/custom-ohgar-category-blocks/custom-ohgar-category-blocks.module';
import { CustomOhgarTabsModule } from '../custom/cms-components/content/custom-ohgar-tabs/custom-ohgar-tabs.module';
import { CustomOhgarTextAndFloatingBannerModule } from '../custom/cms-components/content/custom-ohgar-text-and-floating-banner/custom-ohgar-text-and-floating-banner.module';
import { CustomOhgarTextStaticBannerModule } from '../custom/cms-components/content/custom-ohgar-text-static-banner/custom-ohgar-text-static-banner.module';
import { CustomOurBrandsModule } from '../custom/cms-components/content/custom-our-brands/custom-our-brands.module';
import { CustomOurStoresModule } from '../custom/cms-components/content/custom-our-stores/custom-our-stores.module';
import { CustomOutletGridModule } from '../custom/cms-components/content/custom-outlet-grid/custom-outlet-grid.module';
import { CustomProductItemModule } from '../custom/cms-components/content/custom-product-item/custom-product-item.module';
import { CustomReverseBannerModule } from '../custom/cms-components/content/custom-reverse-banner/custom-reverse-banner.module';
import { CustomSimpleProductItemModule } from '../custom/cms-components/content/custom-simple-product-list/custom-simple-product-item/custom-simple-product-item.module';
import { CustomSimpleProductListModule } from '../custom/cms-components/content/custom-simple-product-list/custom-simple-product-list.module';
import { CustomSiteLogoModule } from '../custom/cms-components/content/custom-site-logo/custom-site-logo.module';
import { CustomTabLoginModule } from '../custom/cms-components/content/custom-tab-login/custom-tab-login.module';
import { CustomTwoSquareSelectionModule } from '../custom/cms-components/content/custom-two-square-selection/custom-two-square-selection.module';
import { CustomUnavailableProductsModule } from '../custom/cms-components/content/custom-unavailable-products/custom-unavailable-products.module';
import { CustomVerticalFourSelectionModule } from '../custom/cms-components/content/custom-vertical-four-selection/custom-vertical-four-selection.module';
import { CustomVerticalTwoAndThreeSelectionModule } from '../custom/cms-components/content/custom-vertical-two-and-three-selection/custom-vertical-two-and-three-selection.module';
import { CustomFamiliesModule } from '../custom/cms-components/families/custom-families/custom-families.module';
import { CustomCareCompanyModule } from '../custom/cms-components/forms/custom-care-company/custom-care-company.module';
import { CustomContactUsModule } from '../custom/cms-components/forms/custom-contact-us/custom-contact-us.module';
import { CustomHelpComponentModule } from '../custom/cms-components/forms/custom-help/custom-help-component.module';
import { CustomOrderReturnModule } from '../custom/cms-components/forms/custom-order-return/custom-order-return.module';
import { CustomWorkWithUsModule } from '../custom/cms-components/forms/custom-work-with-us/custom-work-with-us.module';
import { CustomStoreReviewsCarouselModule } from '../custom/cms-components/trustedshops/custom-store-reviews-carousel/custom-store-reviews-carousel.module';
import { CustomTrustedShopsWidgetModule } from '../custom/cms-components/trustedshops/custom-truestedshops-widget/custom-trustedshops-widget.module';
import { CustomDatePickerModule } from '../custom/forms/date-picker/custom-date-picker.module';
import { CustomFileUploaderModule } from '../custom/forms/file-uploader/custom-file-uploader.module';
import { CustomIconsModule } from '../custom/icons/custom-icons.module';
import { CustomPipesModule } from '../custom/pipes/custom-pipes';
import { CustomOnNavigateConfig } from '../custom/routes/custom-on-navigate-config';
import { CustomAddToCartModule } from './custom/cms-components/cart/custom-add-to-cart/custom-add-to-cart.module';
import { CustomAddedToCartDialogModule } from './custom/cms-components/cart/custom-add-to-cart/custom-added-to-cart-dialog/custom-added-to-cart-dialog.module';
import { CustomAddToWishListModule } from './custom/cms-components/cart/custom-add-to-whish-list/custom-add-to-wish-list.module';
import { CustomCartCouponModule } from './custom/cms-components/cart/custom-cart-coupon/custom-cart-coupon.module';
import { CustomCartDetailsModule } from './custom/cms-components/cart/custom-cart-details/custom-cart-details.module';
import { CustomCartSharedModule } from './custom/cms-components/cart/custom-cart-shared/custom-cart-shared.module';
import { CustomCartTotalsModule } from './custom/cms-components/cart/custom-cart-totals/custom-cart-totals.module';
import { CustomMiniCartModule } from './custom/cms-components/cart/custom-mini-cart/custom-mini-cart.module';
import { CustomCheckoutComponentModule } from './custom/cms-components/checkout/components/custom-checkout.module';
import { CustomCreditCardModule } from './custom/cms-components/checkout/components/custom-credit-card/custom-credit-card.module';
import { CustomAddressFormModule } from './custom/cms-components/checkout/components/custom-shipping-address/address-form/custom-address-form.module';
import { CustomShippingAddressModule } from './custom/cms-components/checkout/components/custom-shipping-address/custom-shipping-address.module';
import { CustomPaymentMethodModule } from './custom/cms-components/checkout/components/payment-method/custom-payment-method.module';
import { CustomBannerCarouselModule } from './custom/cms-components/content/custom-banner-carousel/custom-banner-carousel.module';
import { CustomBannerModule } from './custom/cms-components/content/custom-banner/custom-banner.module';
import { CustomParagraphModule } from './custom/cms-components/content/custom-paragraph/custom-paragraph.module';
import { CustomTabParagraphContainerModule } from './custom/cms-components/content/custom-tab-paragraph-container/custom-tab-paragraph-container.module';
import { CustomTicketsModule } from './custom/cms-components/myaccount/custom-tickets/custom-tickets.module';
import { CustomWishlistStoreModule } from './custom/cms-components/myaccount/custom-wishlist/custom-wishlist.module';
import { CustomInvoicesModule } from './custom/cms-components/myaccount/invoices/custom-invoices.module';
import { CustomNotifyMeModule } from './custom/cms-components/myaccount/notify-me/custom-notify-me.module';
import { CustomOrderDetailsModule } from './custom/cms-components/myaccount/order/custom-order-details';
import { CustomOrderHistoryModule } from './custom/cms-components/myaccount/order/custom-order-history/custom-order-history.module';
import { CustomBreadcrumbFormsPageTemplateModule } from './custom/cms-components/navigation/custom-breadcrumb-formsPageTemplate/custom-breadcrumb-formsPageTemplate.module';
import { CustomBreadcrumbModule } from './custom/cms-components/navigation/custom-breadcrumb/custom-breadcrumb.module';
import { CustomCMSLinkComponentModule } from './custom/cms-components/navigation/custom-cms-link/custom-cms-link.module';
import { CustomFooterNavigationModule } from './custom/cms-components/navigation/custom-footer-navigation/custom-footer-navigation.module';
import { CustomSearchBoxModule } from './custom/cms-components/navigation/custom-search-box/custom-search-box.module';
import { CustomCategoryNavigationModule } from './custom/cms-components/navigation/navigation/custom-category-navigation/category-navigation.module';
import { CustomNavigationModule } from './custom/cms-components/navigation/navigation/custom-navigation.module';
import { CustomOrderConfirmationModule } from './custom/cms-components/order-confirmation/custom-order-confirmation.module';
import { CustomProductCarouselModule } from './custom/cms-components/product/carousel/custom-product-carousel/custom-product-carousel.module';
import { CustomProductReferencesModule } from './custom/cms-components/product/carousel/custom-product-references/custom-product-references.module';
import { CustomOnetrustCookieConfModule } from './custom/cms-components/product/custom-onetrust-cookie-conf/custom-onetrust-cookie-conf.module';
import { CustomOnetrustCookieModule } from './custom/cms-components/product/custom-onetrust-cookie/custom-onetrust-cookie.module';
import { CustomProductImagesModule } from './custom/cms-components/product/custom-product-images/custom-product-images.module';
import { CustomProductIntroModule } from './custom/cms-components/product/custom-product-intro/custom-product-intro.module';
import { CustomProductListModule } from './custom/cms-components/product/custom-product-list/custom-product-list.module';
import { CustomProductSummaryModule } from './custom/cms-components/product/custom-product-summary/custom-product-summary.module';
import { CustomStockNotificationModule } from './custom/cms-components/product/custom-stock-notification/custom-stock-notification.module';
import { CustomActiveFacetsModule } from './custom/cms-components/product/product-list/product-facet-navigation/active-facets/custom-active-facets.module';
import { CustomFacetListModule } from './custom/cms-components/product/product-list/product-facet-navigation/custom-facet-list/custom-facet-list.module';
import { CustomFacetModule } from './custom/cms-components/product/product-list/product-facet-navigation/custom-facet/custom-facet.module';
import { CustomProductFacetNavigationModule } from './custom/cms-components/product/product-list/product-facet-navigation/custom-product-facet-navigation.module';
import { CustomProductComercialModule } from './custom/cms-components/product/product-tabs/custom-product-comercial/custom-product-comercial.module';
import { CustomProductReviewsTrustedshopsModule } from './custom/cms-components/product/product-tabs/custom-product-reviews-trustedshops/custom-product-reviews-trustedshops.module';
import { CustomProductReviewsModule } from './custom/cms-components/product/product-tabs/custom-product-reviews/custom-product-reviews.module';
import { CustomProductTechnicalCharcModule } from './custom/cms-components/product/product-tabs/custom-product-technical-charc/custom-product-technical-charc.module';
import { CustomProductUseMantainanceModule } from './custom/cms-components/product/product-tabs/custom-product-use-mantainance/custom-product-use-mantainance.module';
import { CustomInternalServerModule } from './custom/cms-structure/layout/custom-internal-server/custom-internal-server.module';
import { CustomLayoutModule } from './custom/cms-structure/layout/custom-layout.module';
import { CustomHamburguerMenuModule } from './custom/layout/header/custom-hamburguer-menu/custom-hamburguer-menu.module';
import { EntryGroup } from './custom/model/entry-groups.model';
import { Unit } from './custom/model/unit';
import { CustomCardModule } from './custom/shared/components/custom-card/custom-card.module';
import { CustomCarouselModule } from './custom/shared/components/custom-carousel/custom-carousel.module';
import { CustomGenericLinkModule } from './custom/shared/components/custom-generic-link/custom-generic-link.module';
import { CustomItemCounterModule } from './custom/shared/components/custom-item-counter/custom-item-counter.module';
import { CustomMediaModule } from './custom/shared/components/custom-media/custom-media.module';
import { CustomOrderOverviewModule } from './custom/shared/components/custom-order-overview/custom-order-overview.module';
import { CustomStarRatingModule } from './custom/shared/components/custom-star-raiting/custom-star-rating.module';
import { RecaptchaModule } from './features/recaptcha/recaptcha.module';
import { CustomCheckoutLoginModule } from './features/user/account/components/custom-checkout-login/custom-checkout-login.module';
import { CustomForgotPasswordModule } from './features/user/account/components/custom-forgot-password/custom-forgot-password.module';
import { CustomLoginFormModule } from './features/user/account/components/custom-login-form/custom-login-form.module';
import CMSPage = Occ.CMSPage;

registerLocaleData(es);

@NgModule({
  imports: [
    CommonModule,
    CustomCarouselModule,
    CustomProductCarouselModule,
    CustomLayoutModule,
    CustomCmsItemModule,
    CustomDoubleBannerModule,
    CustomOurBrandsModule,
    CustomCollectionsModule,
    CustomProductReferencesModule,
    CustomIconsModule,
    CustomReverseBannerModule,
    CustomAddToCartModule,
    CustomAddedToCartDialogModule,
    CustomMoreInfoModule,
    CustomCategoryCarouselModule,
    CustomBannerModule,
    CustomTabParagraphContainerModule,
    CustomProductIntroModule,
    CustomAddToWishListModule,
    CustomProductTechnicalCharcModule,
    CustomProductUseMantainanceModule,
    CustomProductSummaryModule,
    CustomNavigationModule,
    CustomFooterNavigationModule,
    CustomGenericLinkModule,
    CustomCMSLinkComponentModule,
    CustomMiniCartModule,
    CustomHamburguerMenuModule,
    CustomCategoryNavigationModule,
    CustomItemCategoryBlocksComponentModule,
    CustomOhgarCategoryBlocksModule,
    CustomItemInfoBoxModule,
    CustomInfoBoxesModule,
    CustomVerticalFourSelectionModule,
    CustomItemVerticalFourModule,
    CustomOhgarTextAndFloatingBannerModule,
    CustomTwoSquareSelectionModule,
    CustomOhgarTextStaticBannerModule,
    CustomItemVerticalTwoAndThreeSelectionModule,
    CustomVerticalTwoAndThreeSelectionModule,
    CustomOhgarTabsModule,
    CustomOhgarBannerAndProductsModule,
    CustomAdditionalTextPdpModule,
    CustomProductComercialModule,
    CustomStarRatingModule,
    CustomProductReviewsModule,
    CustomProductImagesModule,
    CustomProductListModule,
    CustomFamiliesModule,
    CustomCartSharedModule,
    CustomCartTotalsModule,
    CustomCartCouponModule,
    CustomCartDetailsModule,
    CustomLoginFormModule,
    CustomCheckoutComponentModule,
    CustomWishlistStoreModule,
    CustomCreditCardModule,
    CustomAddressFormModule,
    CustomCardModule,
    CustomOrderOverviewModule,
    CustomOrderConfirmationModule,
    CustomOrderHistoryModule,
    CustomPaymentMethodModule,
    CustomAddressFormModule,
    CustomShippingAddressModule,
    CustomOrderDetailsModule,
    CustomHeaderCategoryModule,
    CustomFacetModule,
    CustomFacetListModule,
    CustomProductFacetNavigationModule,
    CustomActiveFacetsModule,
    CustomProductItemModule,
    CustomStockNotificationModule,
    CustomInvoicesModule,
    CustomNotifyMeModule,
    CustomTicketsModule,
    CustomWishlistStoreModule,
    CustomNewsletterModule,
    CustomCheckoutLoginModule,
    CustomTabLoginModule,
    CustomLogoModule,
    CustomOutletGridModule,
    CustomItemAccordionModule,
    CustomAccordionModule,
    CustomButtonSwitchModule,
    CustomPipesModule,
    CustomUnavailableProductsModule,
    CustomSearchBoxModule,
    CustomLinkListModule,
    CustomSimpleProductListModule,
    CustomSimpleProductItemModule,
    CustomItemCounterModule,
    CustomForgotPasswordModule,
    CustomCareCompanyModule,
    CustomContactUsModule,
    CustomHelpComponentModule,
    CustomWorkWithUsModule,
    CustomOrderReturnModule,
    CustomFileUploaderModule,
    CustomHelpModule,
    CustomInfoboxformModule,
    CustomSiteLogoModule,
    CustomBannerCarouselModule,
    CustomOurStoresModule,
    CustomParagraphModule,
    CustomTrustedShopsWidgetModule,
    CustomProductReviewsTrustedshopsModule,
    CustomStoreReviewsCarouselModule,
    CustomParagraphModule,
    RecaptchaModule,
    CustomOnetrustCookieModule,
    CustomOnetrustCookieConfModule,
    CustomInternalServerModule,
    CustomBreadcrumbModule,
    CustomBreadcrumbFormsPageTemplateModule,
    CustomDatePickerModule,
    CustomMediaModule
  ],
  declarations: [],
  exports: []
})
export class SpartacusCustomModule {}

declare module '@spartacus/core' {
  interface CmsLinkComponent {
    icon?: CmsBannerComponentMedia | CmsResponsiveBannerComponentMedia;
    category?: Category;
    name?: string;
  }

  interface Category {
    component?: any;
    description?: string;
    categoryCanonicalUrl?: string;
    categoryMetaTitle?: string;
    title?: string;
    categoryLongDescription?: string;
    categoryBottomLongDescription?: string;
    familyText?: string;
    families?: Category;
    banner?: CustomCmsItemComponent;
    isBannerVisible?: boolean;
    dameroMetaTitle?: string;
    dameroMetaDescription?: string;
    customTitle?: string;
  }

  interface CmsBannerCarouselComponent {
    responsiveBanners?: string;
    timeout: string;
  }

  interface CmsProductCarouselComponent {
    readMoreText?: string;
    description?: string;
    background?: string;
    image?: Media;
    productCodes?: string;
  }

  interface PaymentDetails {
    hasError?: string;
    paymentInfo?: string;
  }

  interface CmsBannerComponent {
    backgroundSlide?: string;
    buttonText?: string;
    backgroundButton?: string;
    colorTextButton?: string;
    sizeTextButton?: string;
    boldTextButton?: string;
    colorText?: string;
    sizeText?: string;
    boldText?: string;
    videoURL?: string;
    positionText?: string;
    titleTag?: string;
    responsiveBanners?: CmsBannerComponentMedia;
  }

  interface UserSignUp {
    firstName?: string;
    contactPerson?: string;
    documentIdentifier?: string;
    jobType?: string;
    line1?: string;
    town?: string;
    mobilePhone?: string;
    postalCode?: string;
    regionCode?: string;
    countryCode?: string;
    userTaxGroup?: string;
    newsletter?: boolean;
    exclusiveRole?: string;
    termsAndConditions?: boolean;
  }

  interface PaymentTypeList {
    paymentModes?: Array<PaymentType>;
    paymentTypes?: Array<PaymentType>;
  }

  interface PaymentType {
    media?: Media;
  }

  interface Stock {
    notifiable?: boolean;
    message?: string;
    visible?: boolean;
    purchasable?: boolean;
  }

  interface ArcLocalizedAttribute {
    code?: string;
    name?: string;
    sapCode?: string;
    pictoCode?: string;
  }

  interface ArcProductLogistic {
    catalogVersion?: string;
    logisticType?: string;
    Number?: number;
    code?: string;
    piece?: string;
    lengthy?: string;
    width?: string;
    high?: string;
    netWeight?: string;
    grossWeight?: string;
    volume?: string;
    mantlePallet?: string;
    packaging?: ArcLocalizedAttribute;
    metricUnit?: string;
    grossWeightUnit?: string;
    netWeightUnit?: string;
    unitIndicator?: string;
  }

  interface Picto {
    code: string;
    name: string;
    image: Media;
  }

  interface Price {
    discountValue?: Price;
    originalPrice?: Price;
    value?: number;
    discountPercentage?: number;
  }

  interface CMSPage {
    robotTag?: PageRobots;
  }

  interface Page {
    redirectUrl?: string;
  }

  enum PageRobots {
    INDEX_FOLLOW = 'INDEX_FOLLOW',
    NOINDEX_FOLLOW = 'NOINDEX_FOLLOW',
    INDEX_NOFOLLOW = 'INDEX_NOFOLLOW',
    NOINDEX_NOFOLLOW = 'NOINDEX_NOFOLLOW'
  }
  interface ProductSearchPage {
    nameHtml?: string;
    name?: string;
    title?: string;
    categoryDescription?: string;
    categoryMetaTitle?: string;
    categoryMetaDescription?: string;
    categoryCanonicalUrl?: string;
    categoryLongDescription?: string;
    familyText?: string;
    dameroMetaTitle?: string;
    dameroMetaDescription?: string;
    customTitle?: string;
  }

  interface OrderEntry {
    unit?: Unit;
    price?: Price;
    maxQuantityRuleStock?: number;
  }

  interface Address {
    billing?: boolean;
    documentIdentifier?: string;
    sameAsShippingAddress?: boolean;
    professional?: boolean;
    consumer?: boolean;
    visibleInAddressBook?: boolean;
  }

  interface Product {
    quantityRoundingProfile?: number;
    arcInstructionsForUse?: ArcLocalizedAttribute[];
    averageRating?: number;
    arcModel?: string;
    arcCleaningAdvices?: ArcLocalizedAttribute[];
    arcGeneralMaterialType1?: ArcLocalizedAttribute;
    arcGeneralMaterialType2?: ArcLocalizedAttribute;
    arcGeneralMaterialType3?: ArcLocalizedAttribute;
    arcDimension?: string;
    arcTotalPieces?: number;
    arcShapes?: ArcLocalizedAttribute[];
    arcColours?: ArcLocalizedAttribute[];
    arcFinishes?: ArcLocalizedAttribute[];
    arcTechnicalCharacteristics?: ArcLocalizedAttribute[];
    diameter?: number;
    capacity?: number;
    footHeight?: number;
    rimThickness?: number;
    totalLength?: number;
    longBlade?: number;
    thickness?: number;
    depth?: number;
    pressure?: number;
    quantityCapacityCups?: ArcLocalizedAttribute;
    bottomType?: ArcLocalizedAttribute;
    nonstickCoating?: ArcLocalizedAttribute;
    typeOfNonstick?: ArcLocalizedAttribute;
    handlesQuantity?: ArcLocalizedAttribute;
    wing?: ArcLocalizedAttribute;
    capsQuantity?: ArcLocalizedAttribute;
    pommel?: ArcLocalizedAttribute;
    handle?: ArcLocalizedAttribute;
    arcTypePackaging?: ArcLocalizedAttribute;
    arcFinishingPackaging?: ArcLocalizedAttribute;
    sapEAN?: string;
    productLogistics?: ArcProductLogistic;
    additionalText?: string;
    pictos?: Picto[];
    stock?: Stock;
    subTitle?: string;
    categoryTags?: string[];
    stockMessage?: string;
    metadescriptionOhgar?: string;
    customCanonicalUrl?: Product;
    metakeywordsOhgar?: string;
    usesTypes?: string[];
    dloosePieceLengthCM?: number;
    dloosePieceWidthCM?: number;
    dheightOfLoosePieceCM?: number;
  }

  interface User {
    professional?: boolean;
    billing?: boolean;
    consumer?: boolean;
    birthday?: any;
    contactEmail?: string;
    commercialName?: string;
    documentIdentifier?: string;
    defaultBillingAddress?: Address;
    jobType?: JobType;
    contactPerson?: string;
    userTaxGroup?: UserTaxGroup;
  }

  interface Stock {
    notifiable?: boolean;
    purchasable?: boolean;
    maxQuantity?: number;
  }

  interface OrderHistory {
    billingAddress: {
      consumer: boolean;
      id: string;
      professional: false;
      billingAddress: true;
      visibleInAddressBook: true;
    };
    carrierName: string;
    carrierUrl: string;
    currency: Currency;
    customer: any;
    customerOrderReference: string;
    date: string;
    deliveryAddress: Address;
    deliveryNotePdf: string;
    entries: Array<OrderEntry>;
    financialDiscount: Price;
    orderDiscount: Price;
    orderPdf: string;
    orderRequest: string;
    orderStatus: string;
    plannedDate: string;
    receiverUid: string;
    specialManagement: string;
    shipping: Price;
    source: string;
    subTotal: Price;
    taxBase: Price;
    taxes: Price;
    totalOrder: Price;
    transportCode: string;
    transportExpedition: string;
    typeOfOrder: string;
    paymentMode: string;
  }

  interface OrderHistoryList {
    orders?: OrderHistory[];
    date?: string;
  }

  enum HttpResponseStatus {
    MOVED_PERMANENTLY = 301,
    FOUND = 302
  }

  interface Config extends CustomOnNavigateConfig {}
}

declare module '@spartacus/cart/base/root' {
  interface Cart {
    paymentMode?: PaymentType;
    entryGroups?: EntryGroup[];
    amountForFreeDelivery?: number;
    possibleFreeDelivery?: boolean;
    freeDelivery?: boolean;
    customer?: User;
    deliveryZone?: any;
  }
}

export interface JobType {
  code?: string;
  name?: string;
}

export interface DocumentIdentifierType {
  code?: string;
  name?: string;
}

export interface UserTaxGroup {
  code?: string;
  name?: string;
}

export enum CUSTOM_LAUNCH_CALLER {
  VALIDATE_CART_SPINNER = 'VALIDATE_CART_SPINNER',
  SIMULATE_CART_SPINNER = 'SIMULATE_CART_SPINNER',
  ORDER_ACTIONS_SPINNER = 'ORDER_ACTIONS_SPINNER',
  PAYPAL_ACTIONS_SPINNER = 'PAYPAL_ACTIONS_SPINNER'
}

declare module '@spartacus/setup/ssr' {
  interface RenderingStrategyResolverOptions {
    expectedCrawlers?: string[];
  }
}

declare module '@spartacus/storefront' {
  enum LAUNCH_CALLER {
    VALIDATE_CART_SPINNER = 'VALIDATE_CART_SPINNER'
  }

  interface NavigationNode {
    icon?: Media;
    name?: string;
    hasEntries?: boolean;
  }

  interface SearchCriteria {
    page?: number;
  }
}
(LAUNCH_CALLER as any)['VALIDATE_CART_SPINNER'] = 'VALIDATE_CART_SPINNER';

declare module '@spartacus/order/root' {
  interface Order {
    sendTo?: string;
    invoicedTo?: Principal;
    paymentMode?: PaymentType;
    entryGroups?: EntryGroup[];
    billingAddress?: Address;
    customerOrderReference?: string;
    customer?: User;
    confirmationChecked?: boolean;
  }
}
